define(['passwordStrength'], function(passwordStrength) {
  let Logon = {
    /**
     * Initializing the module.
     */
    init: function() {
      
      COSTCO.util.maskMembershipInput();
      
      this.allowSignIn();
      this.validationRules();
      this.validate();
      this.validateMemberRestricted();
      this.popovers();
      this.focusInput();
      this.addMaskToZipInput($('#deliveryZipCode'));
      this.addMaskToZipInput($('#userRegdeliveryZipCode'));
      passwordStrength.init();
    },
    /**
     * We want to focus the user on the logon id (email) if
     * it exists, otherwise we want to focus on the password input
     * in the case of "change password"
     * @return {void}
     */
    focusInput: function() {
      // Adding a window load so the focus waits until the login form is drawn.
      // Causes the footer to be viewed if logon form has been drawn yet.
    	$(window).on('load',function() {
        let $focusInput = $('#ChangePasswordForm #membershipNumber').length > 0 ?
          $('#ChangePasswordForm #membershipNumber') :
          $('#logonId, #register_email1, #logonPasswordOld');
        let $password = $('#logonPassword');
        $focusInput.length > 0 ? $focusInput.focus() : $password.focus();
        window.scrollTo(0, 0);
      });
    },
    /**
     * ALM2982
     * We want to disable sign in before the whole logon page is loaded, because clicking sign in button before end of page load, may result in odd behaviour
     * 
     * @return {void}
     */
    allowSignIn: function() {
	  $('#sign_in_button').attr('disabled', true);	
	  $(window).on('load',function() {
        $('#sign_in_button').attr('disabled', false);
        referrerURL = document.referrer;
        url = document.URL;
    	
        // if we're redirectd from the ChangePassword Page, We need to show the success page
        if (((!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && (referrerURL.indexOf('ChangePassword') > -1 || referrerURL.indexOf('ResetPassword') > -1))
        		|| (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && referrerURL.indexOf('AccountPasswordUpdate') > -1))
        		&& url.indexOf('LogonForm') > -1 && !$('#passwordSuccessMessage').length > 0  ){
        	$('#passwordSuccessLogonMessage').removeClass('hide');
        } else {
        	$('#passwordSuccessLogonMessage').addClass('hide');
        }
      });
      
    },
    /**
     * Tool tips.
     */
    popovers: function() {
      $('.co-info, .co-help').popover();
    },
    /**
     * The validation rules for the inputs assoicated with signing in,
     * creating an account, and forgot password.
     */
    validationRules: function() {
      $.validator.addMethod('email', function(value, element) {
        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
      }, messages.JS_VALID_EMAIL);
      $.validator.addMethod('passwordRule', function(value, element) {
        return /^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value);
      }, messages.JS_VALID_REQUIRED);
      $.validator.addMethod('costcoMembership', function(value, element) {
        return this.optional(element) || /^\d{12,16}$/.test(value);
      }, messages.ERR_INVALID_MEMBERSHIP_NO);
      $.validator.addMethod('countryspecificpostalcode', function(value, element, params) {
        let zip_pattern = new RegExp(document.getElementById('zipcode_patterns').getAttribute('value'));
        return this.optional(element) || zip_pattern.test($.trim(value));
      }, messages.ERR_ENTER_ZIPCODE);
    },
    /**
     * Used in the LogonForm submit handler, this logic sets the cookie based
     * on the user's choice of checking the "Remember Me" checkbox.
     */
    rememberMe: function() {
      if ($('#option1').is(':checked')) {
        $.cookie('rememberedLogonId', $('#logonId').val(), {
          expires: 14,
          path: '/',
        });
      } else if($('#option1').length > 0) {
        $.cookie('rememberedLogonId', null, {
          path: '/',
        });
      }
    },
    /**
     * gets base64 encoded referrer for redirecting user back to the page
     * they were on after logging in.
     */
    getLogonRedirectURL: function() {
      let url;
      // if there is already a value for this input (pharmacy is always home-delivery),
      // then don't change the redirect url to the previous page.
      if ($('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val()) {
        url = $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val();
      } else {
        url = document.referrer;
        // if the referrer isn't a category/search/landing/product and isn't our domain,
        // set the url to homepage
        if (!((url.indexOf('.html') > -1 || url.indexOf('/CatalogSearch') > -1) &&
            url.indexOf(location.protocol + '//' + location.host) == 0)) {
          url = '/';
        }
      }
      // need to encode to get past xss filter
      return COSTCO.util.encode(url);
    },

    requireMembership: function(form, fieldName) {
      if ($(form).length == 0) {
        return;
      }

      form.rules('add', {
        required: true,
        costcoMembership: true,
        messages: {
          required: messages.JS_VALID_REQUIRED,
          costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
        },
      });
    },
    /**
     * Validation for the membership restricted form
     */
    validateMemberRestricted: function() {
      $('#MembershipInformationUpdate').validate({
        rules: {
          membershipNumber: {
            required: true,
            costcoMembership: true,
          },
        },
        messages: {
          membershipNumber: {
            required: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
        submitHandler: function(form) {
          // This we don't want trailing whitespace.
          $('#membershipNumber').val($('#membershipNumber').val().trim());
          form.submit();
        },
      });
    },
    /**
     * Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
     */
    addMaskToZipInput : function(zipInput){
    	if (zipInput){
	    	// Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	    	if ((shippingCountries != null) && (shippingCountries.length > 0) && (shippingCountries[0] == "US")) {
	    		zipInput.unmask().mask('00000-0000');
	    	}
    	}
    },
    /**
     * Validate the given forms.
     */
    validate: function() {
      $('#LogonForm, #LogonFormBD, #ResetPasswordForm').validate({
        rules: {
          logonId: {
            required: true,
            email: true,
            maxlength: 251
          },
          logonPassword: {
            required: true,
          },
          deliveryZipCode: {
            required: true,
            countryspecificpostalcode: true,
          },
        },
        messages: {
          logonId: {
            required: messages.ERR_REQUIRED_LOGON,
            email: messages.ERR_INVALID_EMAIL,
            maxlength: messages.ERR_EMAIL_MAX_LENGTH
          },
          logonPassword: {
            required: messages.ERR_REQUIRED_PASSWORD,
          },
          deliveryZipCode: {
            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
          },
        },
        submitHandler: function(form) {
          this.rememberMe();
          // This we don't want trailing whitespace.
          $('#logonId').val($('#logonId').val().trim());

          let url = this.getLogonRedirectURL();
          $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val(url);

          //remove changeValidationFlag from storage session
          sessionStorage.removeItem("changeValidationFlag");
          
          form.submit();
        }.bind(this),
      });
      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
        $('#ChangePasswordForm').validate({
          rules: {
            logonPasswordOld: {
              required: true,
            },
            logonPassword: {
              passwordRule: true,
            },
            logonPasswordVerify: {
              required: true,
              passwordRule: true,
              equalTo: '#logonPassword',
            },
          },
          messages: {
            logonPasswordOld: {
              password: messages.JS_VALID_REQUIRED,
            },
            logonPassword: {
              passwordRule: messages.JS_VALID_REQUIRED,
            },
            logonPasswordVerify: {
              required: messages.CONFIRM_PASSWORD,
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH,
            },
          },
        });
        $('#RegisterForm').validate({
          rules: {
            email1: {
              required: true,
              email: true,
              maxlength:251
            },
            logonPassword: {
              passwordRule: true,
            },
            logonPasswordVerify: {
              required: true,
              passwordRule: true,
              equalTo: '#logonPassword',
            },
            userField2: {
              costcoMembership: true,
            },
            userRegdeliveryZipCode: {
              required: true,
              countryspecificpostalcode: true,
            },
          },
          messages: {
            email1: {
              required: messages.ERR_REQUIRED_LOGON,
              email: messages.ERR_INVALID_EMAIL,
              maxlength: messages.ERR_EMAIL_MAX_LENGTH
            },
            logonPassword: {
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
            },
            logonPasswordVerify: {
              required: messages.CONFIRM_PASSWORD,
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH,
            },
            userField2: {
              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
            },
            userRegdeliveryZipCode: {
              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
            },
          },
        });
      } else {
        $('#RegisterForm, #ChangePasswordForm').validate({
          rules: {
            email1: {
              required: true,
              email: true,
              maxlength:251
            },
            logonPassword: {
              passwordRule: true,
            },
            logonPasswordVerify: {
              required: true,
              passwordRule: true,
              equalTo: '#logonPassword',
            },
            userField2: {
              costcoMembership: true,
            },
            userRegdeliveryZipCode: {
              required: true,
              countryspecificpostalcode: true,
            },
          },
          messages: {
            email1: {
              required: messages.ERR_REQUIRED_LOGON,
              email: messages.ERR_INVALID_EMAIL,
              maxlength: messages.ERR_EMAIL_MAX_LENGTH
            },
            logonPassword: {
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
            },
            logonPasswordVerify: {
              required: messages.CONFIRM_PASSWORD,
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH,
            },
            userField2: {
              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
            },
            userRegdeliveryZipCode: {
              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
            },
          },
        });
      }

      if (typeof instacartStatic !== 'undefined' && instacartStatic.enabled) {
        let $membership = $('[name="userField2"]');
        COSTCO.Logon.requireMembership($membership);
      }
      $('#RegisterFormBD').validate({
        rules: {
          email1: {
            required: true,
            email: true,
            maxlength:251
          },
          logonPassword: {
            passwordRule: true,
          },
          logonPasswordVerify: {
            required: true,
            passwordRule: true,
            equalTo: '#logonPassword',
          },
          userField2: {
            required: true,
            costcoMembership: true,
          },
          userRegdeliveryZipCode: {
            required: true,
            countryspecificpostalcode: true,
          },
        },
        messages: {
          email1: {
            required: messages.ERR_REQUIRED_LOGON,
            email: messages.ERR_INVALID_EMAIL,
            maxlength: messages.ERR_EMAIL_MAX_LENGTH
          },
          logonPassword: {
            passwordRule: messages.ERR_REQUIRED_PASSWORD,
          },
          logonPasswordVerify: {
            required: messages.CONFIRM_PASSWORD,
            passwordRule: messages.ERR_REQUIRED_PASSWORD,
            equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH,
          },
          userField2: {
            required: messages.ERR_REQUIRED_COSTCO_BD_MEMBERSHIP_NO,
            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
          userRegdeliveryZipCode: {
            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
          },
        },
      });
      let $membership = $('#ChangePasswordForm #membershipNumber');
      if ($membership.length > 0) {
        // This is for the case where we arrive on the change password
        // page as part of the manual authentication flow
        COSTCO.Logon.requireMembership($membership);
      }

      $('#LinkMembershipForm').validate({
        rules: {
          membershipNumber: {
            required: true,
            costcoMembership: true,
          },
        },
        messages: {
          membershipNumber: {
            required: messages.JS_VALID_REQUIRED,
            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
      });
    },
  };
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.Logon = Logon;
  return Logon;
});



// WEBPACK FOOTER //
// ./js/account/logon.js